import {useCommonStore} from "./useCommonStore";
import {useState, useEffect} from "react";

export const useAccess = () => {
  const {userInfo, setAccess} = useCommonStore();
  const [accessOptions, setAccessOptions] = useState([]);

  useEffect(() => {
    const options = getAccessOptions(userInfo);
    setAccessOptions(options);
  }, [userInfo]);

  const getAccessOptions = (userInfo) => {
    const accessOptions = [];
    const {authLevel, tribe, church, adminCenters, userCenters} = userInfo;
    userCenters?.map(batch => accessOptions.push({...batch, label: `${batch.center.name} ${batch.name}기`}))

    switch (authLevel) {
      case 'HEAD':
        accessOptions.push({label: '총회 관리자'});
        break;
      case 'TRIBE':
        accessOptions.push({...tribe, label: tribe.name + ' 관리자'});
        break;
      case 'CHURCH':
        accessOptions.push({...church, label: church.name + ' 관리자'});
        break;
      default:
        break;
    }
    adminCenters.map(batch => accessOptions.push({...batch, label: `${batch.center.name} ${batch.name}기 관리자`}));

    return accessOptions;
  }

  const selectAccessOption = (option) => {
    if (!!option.centerId) {
      setAccess({
        authLevel: 10,
        label: option.label,
        centerBatch: option,
      });
    } else {
      setAccess({
        authLevel: userInfo.authLevel,
        label: option.label,
        centerBatch: null,
      });
    }
  };

  return {getAccessOptions, selectAccessOption, accessOptions};
}